import services from '../config/services';
import utils from '../config/utils';
import Vue from 'vue';

export default {
    state: {
        navTitle: '学习中心',
        imageCode: {
            key: '',
            img: '',
        },
        schoolInfo: null, // 学校信息 logo
        appsUserInfo: null, // 登录后用户信息
    },
    getters: {},
    actions: {
        // 获取图片验证码
        getAppsImageCaptcha(context, payload) {
            return services.getAppsImageCaptcha(payload).then((res) => {
                // console.log(res);
                if (res.code == '0000') {
                    context.commit('setAppsImageCode', {
                        imageCode: res.data,
                    });
                }
                return res;
            });
        },
        // 获取手机短信验证码
        getAppsSmsCaptcha(context, payload) {
            return services.getAppsSmsCaptcha(payload).then((res) => {
                return res;
            });
        },
        // 登录
        requestAppsLogin(context, payload) {
            return services.postAppsLogin(payload).then((res) => {
                if (res.code == '0000') {
                    localStorage.setItem('appsToken', res.data.token);
                }
                return res;
            });
        },
        // 获取学校信息
        getLoginSchoolInfo(context, payload) {
            return services.getAppsSchoolInfo(payload).then((res) => {
                if (res.code == '0000') {
                    context.commit('setSchoolInfo', {
                        data: res.data ? res.data : [],
                    });
                }
                return res;
            });
        },
        // 获取用户信息
        getAppsLoginUserInfo(context, payload) {
            return services
                .getAppsUserInfo({
                    is_append: 1,
                    is_school: 1,
                })
                .then((res) => {
                    if (res.code == '0000') {
                        if (res.data) {
                            let pathname = window.location.pathname;
                            localStorage.setItem('schoolCode', res.data.school_code);
                            let urlCode = utils.getUrlSchoolCode(pathname);
                            if (pathname.indexOf('hzvtc') == -1 && pathname.indexOf('custom') == -1 && res.data.school_code != urlCode) {
                                window.open(`/center/${res.data.school_code}/user/myClass`, '_self');
                            }
                            utils.setUserInfo(res.data);
                            context.commit('setAppsLoginUserInfo', {
                                userInfo: res.data ? res.data : {},
                            });
                        }
                    }
                    return res;
                });
        },
        // 修改密码、设置新密码
        requestAppsEditPassword(context, payload) {
            return services.postAppsEditPassword(payload).then((res) => {
                return res;
            });
        },
        // 重置密码
        requestAppsResetPassword(context, payload) {
            return services.postAppsResetPassword(payload).then((res) => {
                return res;
            });
        },
        // 官网注册
        requestAppsRegister(context, payload) {
            return services.postAppsRegister(payload).then((res) => {
                if (res.code == '0000') {
                    localStorage.setItem('appsToken', res.data.token);
                }
                return res;
            });
        },
        // 退出登录
        requestAppsLogout(context, payload) {
            let school_code = localStorage.getItem('schoolCode');
            let params = { ...payload };
            params.from = window.location.href;
            // params.from = `${services.LOGIN_SERVER}/${school_code}/login`
            return services.postAppsLogout(params).then((res) => {
                if (res.code == '0000') {
                    utils.removeUserInfo();
                    context.commit('setAppsLoginUserInfo', {
                        userInfo: null,
                    });
                    if (
                        window.location.pathname.indexOf('hzvtc') > -1 ||
                        window.location.pathname.indexOf('party') > -1 ||
                        window.location.pathname.indexOf('clnyy') > -1 ||
                        window.location.pathname.indexOf('hangke/base') > -1
                    )
                        return;
                    if (res.data && res.data.redirect) {
                        window.open(`${res.data.redirect}`, '_self');
                    } else {
                        window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${school_code}&from=${window.location.href}`, '_self');
                    }
                }
                return res;
            });
        },
        // 绑定/换绑手机号
        requestUpdateUserPhone(context, payload) {
            return services.updateUserPhone(payload).then((res) => {
                return res;
            });
        },
        // 解绑微信
        requestWechatUnbind(context, payload) {
            return services.getWechatUnbind(payload).then((res) => {
                return res;
            });
        },
    },
    mutations: {
        setAppsImageCode(state, payload) {
            state.imageCode = payload.imageCode;
        },
        setSchoolInfo(state, payload) {
            state.schoolInfo = payload.data;
        },
        setAppsLoginUserInfo(state, payload) {
            state.appsUserInfo = payload.userInfo;
        },
        setNavTitle(state, payload) {
            Vue.set(state, 'navTitle', payload.navTitle);
        },
    },
};
